import axios from "axios";
import UserService from "rc-app/services/UserService";

export const getAgentProfile = async (email_id) => {
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/realestate/re_agent/profile/${email_id}`;
    const response = await fetch(API_URL, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching gender options:", error);
    return [];
  }
};

export const getAgentById = async (agent_id) => {
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/re_agent/${agent_id}`;
    const response = await fetch(API_URL, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching gender options:", error);
    return [];
  }
};

export const getAllAgent = async (page = 0, limit = 10000, agencyId = null) => {
  try {
    const agencyFilter = agencyId ? `&agency_id=${agencyId}` : "";
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/re_agent?sort_by=created_at&sort_order=-1&page=0&limit=${limit}${agencyFilter}`;
    const response = await fetch(API_URL, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching gender options:", error);
    return [];
  }
};

export const getAgentCustomers = async (agentEmailId) => {
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/re_customer/agent/customer/${agentEmailId}?page=0&limit=20&sort_by=created_at&sort_order=-1`;
    const response = await fetch(API_URL, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching gender options:", error);
    return [];
  }
};

export const createAgent = async (jsonData) => {
  try {
    console.log("create Client", jsonData);

    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/re_agent`;
    const PAYLOAD = {
      ...jsonData,
    };

    const response = await axios.post(API_URL, PAYLOAD, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error creating agent:", error);
    if (error.response?.data) {
      throw error.response.data;
    }
    throw error;
  }
};

export const updateAgent = async (jsonData, agentId) => {
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/re_agent/${agentId}`;
    const PAYLOAD = {
      ...jsonData,
    };

    const response = await axios.put(API_URL, PAYLOAD, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching gender options:", error);
    throw error;
  }
};

export const checkAgentEmailExists = async (email) => {
  try {
    const data = await getAgentProfile(email);
    return data?.agent ? data.agent : null;
  } catch (error) {
    return null;
  }
};

export const checkAgentMobileExists = async (mobile, agencyId) => {
  try {
    const data = await getAllAgent();
    if (!data?.re_agent_list) return null;
    
    const existingAgent = data.re_agent_list.find(
      (agent) => agent.mobile_number === mobile && agent.agency?.["_id"] === agencyId
    );
    return existingAgent || null;
  } catch (error) {
    return null;
  }
};

